export const movieDbUrl = process.env.REACT_APP_BASE_TMDB_URL;
export const movieDbApiKey = process.env.REACT_APP_TMDB_API_KEY;
export const movieDbAccessToken = process.env.REACT_APP_TMDB_ACCESS_TOKEN;
export const movieDbBaseImgUrl = `https://image.tmdb.org/t/p/`;
